import { USER_STATE } from '../../constants.js';

export function changeState(newState) {
  return {
    type: USER_STATE.CHANGE_STATE,
    currentState: newState
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/A_user_states.js